import { obtenerInspiradorPorId } from '../../api/inspiradores'

const state = {
  inspiradorActual: {},
  keyInspiradorActual: ''
}

const mutations = {
  setInspirador: (state, inspirador) => {
    state.inspiradorActual = inspirador
  },
  setKeyInspirador: (state, key) => {
    state.keyInspiradorActual = key
  }
}

const actions = {
  async loadInspirador ({ commit }, idInspirador) {
    const inspiradorDoc = await obtenerInspiradorPorId(idInspirador)
    commit('setKeyInspirador', idInspirador)
    commit('setInspirador', inspiradorDoc.data())
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
